import React from "react";
import { LoadingScreen } from "@packsize/components";
import { Navigate, useLocation } from "react-router-dom";

import { useAuthentication, useUser } from "../../../hooks";
import { appendQueryParameters } from "../../../utils";

interface AuthenticatedRouteProps {
	readonly children: React.ReactNode;
}

const buildLoginUrl = (pathname: string, search: string): string => {
	const currentSearch = new URLSearchParams(search);

	const token = currentSearch.get("token");

	currentSearch.delete("token");

	const cleanedSearch = currentSearch.toString();
	const returnTo = pathname + (cleanedSearch ? `?${cleanedSearch}` : "");

	return appendQueryParameters("/login", { returnTo, token });
};

export const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ children }) => {
	const { authenticated } = useAuthentication();
	const { currentUser } = useUser();
	const location = useLocation();

	if (authenticated === undefined) {
		return <LoadingScreen />;
	}

	if (authenticated === false) {
		return <Navigate to={buildLoginUrl(location.pathname, location.search)} replace />;
	}

	if ((currentUser as { forcePasswordReset?: boolean } | null)?.forcePasswordReset === true) {
		return <Navigate to="/password-reset-complete" replace />;
	}

	return children;
};
